// Puanlanan ya da puanlaması atlanan konusmalar. Ayni konusma icin
// degerlendirme ekrani bir kez cikar; atla da puanlama kadar kalicidir.
const STORAGE_KEY = "rated-chat-ids";
const MAX_KEPT = 50;

export function getRatedChatIds() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        // Bozuk kayit tum ekrani kirmasin
        return [];
    }
}

export function isChatRated(conversationId) {
    if (!conversationId) return false;
    return getRatedChatIds().some((id) => String(id) === String(conversationId));
}

// "Atla" sonrasi yeniden baglanirken sunucu yeni bir conversation id
// veriyor; o id ratedIds'de olmadigi icin ekran tekrar aciliyordu. Kisa
// bir bastirma penceresi id'den bagimsiz olarak bunu kapatir.
const SKIP_KEY = "rating-skipped-at";
const SUPPRESS_MS = 15000;

export function markRatingSkipped() {
    try {
        sessionStorage.setItem(SKIP_KEY, String(Date.now()));
    } catch (error) {
        // Depolama kapaliysa sessizce gec
    }
}

export function isRatingSuppressed() {
    try {
        const raw = sessionStorage.getItem(SKIP_KEY);
        if (!raw) return false;
        return Date.now() - Number(raw) < SUPPRESS_MS;
    } catch (error) {
        return false;
    }
}

export function markChatRated(conversationId) {
    if (!conversationId) return;
    if (isChatRated(conversationId)) return;
    const next = getRatedChatIds().concat(String(conversationId)).slice(-MAX_KEPT);
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
        // Depolama kapaliysa (gizli sekme kotasi) sessizce gec
    }
}



// WEBPACK FOOTER //
// ./src/utils/ratedChats.js